import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SeInitComponent } from "../se.init.component";

@TypeManagerDecorator("s25-ng-se-config-init-page")
@Component({
    selector: "s25-ng-se-config-init-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeInitComponent],
    template: `
        <div class="c-padding--double se-config-page">
            <s25-ng-se-init />
        </div>
    `,
    styles: `
        :host {
            display: block;
        }
    `,
})
export class SeConfigInitPageComponent {}
